import config from '../utils/config'
import request from '../utils/request'

const {api} = config
const {clientVersion, clientVersionOne} = api

/**
 * 查找
 */
export async function findAndroidClient(params) {
    return request({url: clientVersionOne, method: 'get', data: params,})
}

/**
 * 创建
 */
export async function createAndroidClient(params) {
    return request({url: clientVersion, method: 'post', data: params,})
}

/**
 * 更新
 */
export async function updateAndroidClient(params) {
    return request({url: clientVersionOne, method: 'patch', data: params,})
}

/**
 * 删除
 */
export async function deleteAndroidClient(params) {
    return request({url: clientVersionOne, method: 'delete', data: params,})
}


/**
 * 查找列表
 */
export async function findAndroidClients(params) {
    return request({url: clientVersion, method: 'get', data: params,})
}

/**
 * 删除
 */
export async function deleteAndroidClients(params) {
    return request({url: clientVersionOne, method: 'delete', data: params,})
}



// WEBPACK FOOTER //
// ./src/services/androidClient.js